import React, { useState } from "react";
import SimpleButtonWrapper from "../simpleButtonWrapper/simpleButtonWrapper";
import Button from "../button/button";
import ModalContainer from "../modalContainer/modalContainer";
import { useQuery } from "@tanstack/react-query";
import useUser from "../../customHooks/useUser";
import { fetchAskForPlans } from "../../Apis/questionaire";
import LoginLink from "../loginLink/loginLink";

const AskForPlans = ({ disable_documentation, uuid }) => {
  const { uuid: userId, csrfToken, isLoggedIn } = useUser();
  const [showAskForPlans, setShowAskForPlans] = useState(false);
  const askForPlans = useQuery(
    ["ask-for-plans", uuid],
    () => fetchAskForPlans(csrfToken, uuid, userId),
    // A retry would send the request (and the admin email) again.
    { enabled: showAskForPlans, retry: false }
  );

  return (
    <>
      <SimpleButtonWrapper position="left">
        {!disable_documentation &&
          (isLoggedIn ? (
            <Button onClick={() => setShowAskForPlans(true)}>
              ASK FOR PLANS
            </Button>
          ) : (
            // The request is about the signed-in user, as with Subscribe.
            <LoginLink>
              <Button>ASK FOR PLANS</Button>
            </LoginLink>
          ))}
      </SimpleButtonWrapper>
      {showAskForPlans && (
        <ModalContainer
          isOpen={true}
          closeModal={() => setShowAskForPlans(false)}
          title="Ask for plans"
          className="inviteMembersModal"
          shouldCloseOnOverlayClick={false}
        >
          <p>
            {askForPlans.status === "loading"
              ? "Sending email.."
              : askForPlans.status === "error"
              ? "Something went wrong."
              : " Thanks for asking! An NBG representative will contact you as soon as possible."}
          </p>
        </ModalContainer>
      )}
    </>
  );
};

export default AskForPlans;
